import { Component } from '@angular/core';
import { ATableMenuTab } from './mactable.menu.tab';

@Component({
    selector: 'mactable-size-menu-tab',
    templateUrl: './size.menu.tab.html'
})
export class MacTableSizeMenuTab extends ATableMenuTab {
}
